import { Box } from "@mui/material";
import React from "react";
import { clx } from "../../../utils/Helpers";
import UIIcon from "../UIIcon";
import PropTypes from "prop-types";

const variantClassNames = {
  approve: "ui-action-modal--approve",
  info: "ui-action-modal--info",
  reject: "ui-action-modal--reject",
};


const UIActionModalIcon = ({ variant, iconName }) => (
  <Box className={clx("ui-action-modal__icon", variantClassNames[variant])}>
    <UIIcon
      name={iconName}
      width={38}
      height={38}
      color="currentColor"
      strokeWidth={3.11}
      decorative
    />
  </Box>
);

export default UIActionModalIcon;


UIActionModalIcon.propTypes = {
  variant: PropTypes.oneOf(["approve", "info", "reject"]),
  iconName: PropTypes.string,
};

UIActionModalIcon.defaultProps = {
  variant: "approve",
  iconName: "alertCircle",
};
